export default __webpack_public_path__ + "static/media/NestMainHeader.77e60ad9.png";